import React from 'react';

import logo from '../../assets/fewcents_logo.svg';
import styles from './Header.module.css';

const Header = () => (
  <header id={styles.header}>
    <img src={logo} alt="fewcents_logo" id={styles.header__logo} />
    <h1 id={styles.header__text}>Fewcents Admin Page</h1>
    <button id={styles.header__button} type="button">
      <span>Read Documentation</span>
    </button>
  </header>
);

export default Header;
